import { withRouter } from 'react-router-dom';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Switch,
} from '@mui/material';
import { Button } from 'global/components/Button';
import { useTaskTypes } from './useTaskTypes';
import { useScreen } from 'global/styles';
import useStyles from './styles';
import { get } from 'global/lib/lodash';
import { uppercaseFirst } from 'global/utils';
import { CenterLoader } from 'global/styles';

const COLUMNS = [
  {
    field: 'enabled',
    title: 'Enabled',
    render: (row, { onToggleEnabled, modeOff }) => (
      <Switch
        checked={row.is_active}
        onChange={() => onToggleEnabled(row)}
        size="small"
        color="primary"
        disabled={modeOff}
      />
    ),
  },
  {
    field: 'mode',
    title: 'Mode',
    disableStyle: true,
    render: (row) => get(row, 'mode', ''),
  },
  {
    field: 'name',
    title: 'Name',
    disableStyle: true,
    render: (row) => row.name,
  },
  {
    field: 'custom_name',
    title: 'Custom Name',
    disableStyle: true,
    render: (row) => row.custom_name || '',
  },
  {
    field: 'location_types',
    title: 'Location Type(s)',
    disableStyle: true,
    render: (row) => (row.location_types || []).map(uppercaseFirst).join(', '),
  },
  {
    field: 'edit_config',
    title: 'Edit Config',
    align: 'right',
    render: (row, { onConfigure, modeOff }) =>
      row.is_active && !modeOff ? (
        <Button color="primary" size="small" onClick={() => onConfigure(row)}>
          Configure
        </Button>
      ) : null,
  },
];

export default withRouter((props) => {
  const { isMobile } = useScreen();
  const classes = useStyles({ isMobile });
  const { data, loading, updateTaskType, enabledModeIds } = useTaskTypes();

  const onToggleEnabled = (row) => {
    updateTaskType(row.id, { enabled: !row.is_active });
  };

  const onConfigure = (row) => {
    props.history.push(`/account/content/task-type/${row.id}`, { from: 'account/content' });
  };

  if (loading && !data.length) return <CenterLoader />;

  return (
    <div className={classes.container}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {COLUMNS.map((col) => (
                <TableCell key={col.field} className={classes.headerCell} align={col.align}>
                  {col.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {(data || []).map((row) => {
              const modeOff = !enabledModeIds.includes(Number(row._appModeId));
              const disabled = !row.is_active || modeOff;
              return (
                <TableRow key={row.id} className={disabled ? classes.disabledRow : classes.enabledRow}>
                  {COLUMNS.map((col) => (
                    <TableCell
                      key={col.field}
                      align={col.align}
                      className={disabled && col.disableStyle ? classes.disabledText : ''}
                    >
                      {col.render(row, { onConfigure, onToggleEnabled, modeOff })}
                    </TableCell>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
});
